import {
  DropdownSelect,
  FlexBox,
  Icon,
  SelectItem,
} from '@dixa/lib-shared-habla';
import { CollectionManagementNav } from 'collection/pages/collectionEdit/components/layout/layout';
import { ItemType } from 'lib-knowledge-utils/components/itemType';
import Page from 'lib-knowledge-utils/components/page/index';
import { useState } from 'react';
import { DefaultLanguageForm } from 'settings/components/defaultLanguageForm';
import { EnabledLanguagesForm } from 'settings/components/enabledLanguagesForm';
import { z } from 'zod';

import styles from './settingsPage.module.scss';
import { useHandleLanguageSelection } from './useHandleLanguageSelection';

const listItemSchema = z.object({
  name: z.string(),
  id: z.string(),
});
export const knowledgeSettingsFormSchema = z.object({
  defaultLanguage: z.array(listItemSchema),
  enabledLanguageIds: z.array(z.string()),
});

export default function KnowledgeSettingsPage(): JSX.Element {
  const { handleLanguageSelection, inactiveLanguages } =
    useHandleLanguageSelection();

  const [searchTerm, setSearchTerm] = useState<string>('');

  return (
    <Page>
      <Page.Body>
        <CollectionManagementNav />
        <FlexBox
          flexDirection="column"
          width="100%"
          className={styles.pageContainer}
        >
          <Page.Head
            slotLeft={
              <Page.Head
                slotLeft={<Page.HeadTitle title="Knowledge settings" />}
              />
            }
          />
          <FlexBox flexDirection="column">
            <Page.Section title="Settings">
              <DefaultLanguageForm />
            </Page.Section>
            <Page.Section
              title="Enabled languages"
              controls={
                <DropdownSelect
                  fixed
                  noArrow
                  hasSearch
                  onSearch={(value) =>
                    setSearchTerm(value !== undefined ? value : '')
                  }
                  onSelect={handleLanguageSelection}
                  items={[
                    ...inactiveLanguages
                      .filter((lang) =>
                        lang.description
                          .toLowerCase()
                          .includes(searchTerm.toLowerCase()),
                      )
                      .map((lang) => {
                        const item: ItemType = {
                          id: lang.languageId,
                          name: lang.description,
                        };
                        return item;
                      }),
                  ]}
                  selectedItems={[]}
                  itemComponent={SelectItem}
                  dropdownProps={{
                    style: {
                      minWidth: '280px',
                    },
                  }}
                >
                  <FlexBox gap="200">
                    <Icon name="plus" />
                    Enable language
                  </FlexBox>
                </DropdownSelect>
              }
            >
              <EnabledLanguagesForm />
            </Page.Section>
          </FlexBox>
        </FlexBox>
      </Page.Body>
    </Page>
  );
}
